
import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryFolderProfile from "../screens/CategoryManagement/CategoryFolderProfile";

const breadCrumbData = [{ link: "/project-folder-list", name: "Project Folder List" },
{ link: "/project-folder-detail", name: "Project Folder Detail" }];

const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryFolderProfile />
    </LayoutContainer>
  </>
);

export default CategoryManagement;